<script setup>
import {onMounted, ref} from 'vue';
import {Dialog, DialogPanel, DialogTitle, TransitionRoot} from '@headlessui/vue';
import {useI18n} from 'vue-i18n';
import ClientBondService from '@/services/ClientBondService';
import BondPaymentInfo from '@/components/bonds/BondPaymentInfo.vue';

/**
 * IMA-517 fáze 10b: platební údaje nákupu dluhopisu z aplikace (záložka Pokyny na dashboardu klienta).
 * Klient je může zobrazit kdykoli po nákupu, např. když QR na konci průvodce nenaskenoval.
 * BE vrací 404 pro cizí nákup a nákup bez VS (založený mimo aplikaci).
 */
const props = defineProps({
  order: {type: Object, required: true},
});
const emit = defineEmits(['close']);

const {t} = useI18n();
const isOpen = ref(true);
const loading = ref(true);
const payment = ref(null);
const failed = ref(false);

onMounted(() => {
  ClientBondService.getPaymentInfo(props.order.id).then(response => {
    payment.value = response;
  }).catch(() => {
    failed.value = true;
  }).finally(() => {
    loading.value = false;
  });
});

function close() {
  isOpen.value = false;
  emit('close');
}
</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" @close="close" class="modal show d-block" style="z-index: 1055;">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered modal-lg" style="z-index: 1055">
        <div class="modal-content">
          <DialogPanel class="modal-body p-4 rounded-lg shadow-lg">
            <div class="modal-header">
              <DialogTitle as="h3" class="modal-title">{{ t('bondPurchase.payment_title', {name: order.bond?.name ?? ''}) }}</DialogTitle>
              <i class="btn-close cursor-pointer" @click="close" :aria-label="t('bondPurchase.close')"></i>
            </div>
            <div class="modal-body">
              <div v-if="loading" class="text-center my-4">
                <div class="spinner-border text-primary" role="status"><span class="visually-hidden">{{ t('clientBonds.loading') }}</span></div>
              </div>
              <div v-else-if="failed" class="alert alert-danger">{{ t('bondPurchase.payment_not_available') }}</div>
              <BondPaymentInfo v-else :payment="payment"/>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" @click="close">{{ t('bondPurchase.close') }}</button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
